export default __webpack_public_path__ + "static/media/Gnrgy.b2ade2be.png";